export default "__VITE_ASSET__Bv03qA_4__"